import { FunctionComponent, ReactNode, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cx from 'classnames'
import url from 'libraries/front-end-core/core/url'
import BrokenRefDialog from 'components/BrokenRefDialog'
import { CURRENT_AWARENESS_ARTICLE } from 'constants/controllers'
import selectIsLogged from 'redux/selectors/selectIsLogged'
import selectUserAccessRoles from 'redux/selectors/selectAccessRoles'
import { setSignUpModalIsOpen, setUserRolesModalIsOpen } from 'redux/actions'

interface SmartFcNewsReferenceLinkProps {
  children: ReactNode
  attribs: {
    class: string
    'data-articleid'?: string
    'data-areaoflaw'?: string
  }
}

const SmartFcNewsReferenceLink: FunctionComponent<SmartFcNewsReferenceLinkProps> = ({
  children,
  attribs
}) => {
  const dispatch = useDispatch()
  const isLogged = useSelector(selectIsLogged)
  const accessRoles = useSelector(selectUserAccessRoles)
  const [brokenRefModalOpen, setBrokenRefModalOpen] = useState(false)

  const { 'data-articleid': id, 'data-areaoflaw': aol } = attribs

  const isBrokenRef = [id, aol].some(value => (value ?? '') === '')
  const hasNewsAccess = isLogged && accessRoles.some(role => role.startsWith(`${aol ?? ''}_news_`))

  const handleOnClick = (): void => {
    if (isBrokenRef) {
      setBrokenRefModalOpen(true)
    } else if (!isLogged) {
      dispatch(setSignUpModalIsOpen(true))
    } else if (!hasNewsAccess) {
      dispatch(setUserRolesModalIsOpen(true))
    }
  }

  return (
    <>
      <a
        className={cx('fc-news-reference', { pointer: !hasNewsAccess || isBrokenRef })}
        href={hasNewsAccess && !isBrokenRef ? url(CURRENT_AWARENESS_ARTICLE, { aol, id }) : undefined}
        onClick={handleOnClick}
      >
        {children}
      </a>
      <BrokenRefDialog open={brokenRefModalOpen} onClose={() => setBrokenRefModalOpen(false)} />
    </>
  )
}

export default SmartFcNewsReferenceLink
